import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import { INPUT_VARIANT } from "@/common/elements/InputElements/const";
import { IntakeSectionHeader } from "@/common/styles";
import { Col, Row } from "antd";
import { FormContainer } from "../InmateDetails/styles";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import { getOptionsFromRefList } from "@/util/common_function";
import dayjs from "dayjs";
import CommonDatePicker from "@/common/elements/DatePicker";


const DetentionInformation = ({ arrestReport = {}, form, disabled }) => {

  return (
    <>
      <section>
        <IntakeSectionHeader>
          <span>Detention Information</span>
        </IntakeSectionHeader>
        <FormContainer>
          <Row gutter={16}>
            <Col span={8}>
              <FormItem
                name={["detentionsArrestReports", 0, "detentionId"]}
                label="Detention #"
                layout="vertical"
              >
                <TextField disabled />
              </FormItem>
            </Col>
            <Col span={8}>
              <FormItem name={["detentionsArrestReports", 0, "housingAgency"]} label="Facility" layout="vertical">
                <Select
                  options={getOptionsFromRefList("Housing_Agency")}
                  placeholder="Facility"
                  showSearch={false}
                  variant="outlined"
                  disabled={disabled}
                />
              </FormItem>
            </Col>
            <Col span={8}>
              <FormItem name={["detentionsArrestReports", 0, "housingAssignmentBlock"]} label="Block" layout="vertical">
                <TextField disabled />
              </FormItem>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={8}>
              <FormItem
                name={["detentionsArrestReports", 0, "incarcerationDateTime"]}
                label="Incarcerated Date & Time"
                layout="vertical"
              >
                <CommonDatePicker
                  placeholder="MM/DD/YYYY HH:mm"
                  format="MM/DD/YYYY HH:mm"
                  showTime={true}
                  disabled={disabled}
                />
              </FormItem>
            </Col>
                <Col span={8}>
              <FormItem
                name={["detentionsArrestReports", 0, "holdReasonId"]}
                label="Hold Reason"
                layout="vertical"
              >
                <Select
                  options={getOptionsFromRefList(
                    "Inmate_Hold_Reason",
                    false,
                    false,
                    true
                  )}
                  placeholder="Hold Reason"
                  showSearch={false}
                  variant="outlined"
                  disabled={disabled}
                />
              </FormItem>
            </Col>
          </Row>
        </FormContainer>
      </section>
    </>
  );
};

export default DetentionInformation;
